export default __webpack_public_path__ + "static/checklist-38390ab379a5cb04e3cf08a0ec532f90.png";